import ViewImage from 'pages/modal/ViewImage';
import styles from 'styles/components/common/lists/FileList.module.scss';
import { TChartFileInfoList } from 'types/chart';
import { TNoticeFileList } from 'types/form/notice';
import useModal from 'hooks/useModal';

type TProps = {
  value: TChartFileInfoList[] | TNoticeFileList[];
  listStyle?: object;
};

const FileList = (props: TProps) => {
  const { openModal } = useModal();

  const isImage = (fileName: string) => {
    const ext = fileName.split('.').pop()?.toLowerCase();

    return ['jpg', 'jpeg', 'png', 'gif'].includes(ext || '');
  };

  const handleClick = (fileName: string, path: string) => {
    if (isImage(fileName)) {
      viewFile(path);
    } else {
      downloadFile(fileName, path);
    }
  };

  const viewFile = (path: string) => {
    openModal({
      element: <ViewImage path={path} />,
    });
  };

  const downloadFile = async (fileName: string, path: string) => {
    const blob = new Blob([path], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    link.remove();
  };

  return (
    <ul className={styles.file_list} style={{ ...props.listStyle }}>
      {props.value.map((file, index) => (
        <li key={index} className={styles.file}>
          <button
            type="button"
            className={styles.btn}
            onClick={() =>
              handleClick(
                (file as TChartFileInfoList).fileName ||
                  (file as TNoticeFileList).originFileName,
                (file as TChartFileInfoList).filePath ||
                  (file as TNoticeFileList).path
              )
            }
          >
            {(file as TChartFileInfoList).fileName ||
              (file as TNoticeFileList).originFileName}
          </button>
        </li>
      ))}
    </ul>
  );
};

export default FileList;
